// Free Fabric Sample JavaScript
// Handles selection of fabric samples with max 5 limit and add to cart functionality

(function() {
  'use strict';

  const MAX_SAMPLES = 5;
  let selectedSamples = [];

  document.addEventListener('DOMContentLoaded', function() {
    initializeFabricSample();
  });

  function initializeFabricSample() {
    const checkboxes = document.querySelectorAll('input[name="fabric_sample"]');
    const addButton = document.getElementById('add-fabric-samples');
    const selectedCountEl = document.getElementById('selected-count');

    if (!checkboxes.length) return;

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        handleSampleSelection(this);
      });
    });

    if (addButton) {
      addButton.addEventListener('click', function() {
        addSamplesToCart();
      });
    }
  }

  function handleSampleSelection(checkbox) {
    const variantId = checkbox.value;
    const variantTitle = checkbox.dataset.variantTitle || checkbox.dataset.variantTitle || checkbox.closest('.fabric-sample-item').dataset.variantTitle;
    const fullTitle = checkbox.dataset.fullTitle || variantTitle;
    const variantImage = checkbox.dataset.variantImage || '';

    const label = checkbox.closest('.fabric-sample-label');
    
    if (checkbox.checked) {
      if (selectedSamples.length >= MAX_SAMPLES) {
        checkbox.checked = false;
        alert('You can only select up to ' + MAX_SAMPLES + ' samples.');
        return;
      }

      if (label) {
        label.classList.add('selected');
      }

      selectedSamples.push({
        id: variantId,
        title: variantTitle,
        fullTitle: fullTitle,
        image: variantImage,
        quantity: 1
      });
    } else {
      if (label) {
        label.classList.remove('selected');
      }
      
      selectedSamples = selectedSamples.filter(function(sample) {
        return sample.id !== variantId;
      });
    }

    updateUI();
  }

  function updateUI() {
    const selectedCountEl = document.getElementById('selected-count');
    const addButton = document.getElementById('add-fabric-samples');
    const sampleList = document.getElementById('sample-list');
    const selectedSamplesContainer = document.getElementById('selected-samples');

    // Update count
    if (selectedCountEl) {
      selectedCountEl.textContent = selectedSamples.length;
    }

    // Update button state
    if (addButton) {
      addButton.disabled = selectedSamples.length === 0;
    }

    // Update selected samples display
    if (selectedSamples.length > 0 && sampleList) {
      selectedSamplesContainer.style.display = 'block';
      sampleList.innerHTML = '';

      selectedSamples.forEach(function(sample) {
        const li = document.createElement('li');
        li.className = 'sample-item';
        li.dataset.variantId = sample.id;

        let imageHtml = '';
        if (sample.image) {
          imageHtml = '<img src="' + sample.image + '" alt="' + sample.title + '" class="sample-thumb">';
        }

        li.innerHTML = imageHtml + '<span class="sample-title">' + sample.title + '</span><button type="button" class="remove-sample" data-id="' + sample.id + '">×</button>';

        // Add remove event listener
        li.querySelector('.remove-sample').addEventListener('click', function() {
          removeSample(this.dataset.id);
        });

        sampleList.appendChild(li);
      });
    } else if (selectedSamplesContainer) {
      selectedSamplesContainer.style.display = 'none';
    }
  }

  function removeSample(variantId) {
    // Uncheck the corresponding checkbox
    const checkbox = document.querySelector('input[name="fabric_sample"][value="' + variantId + '"]');
    if (checkbox) {
      checkbox.checked = false;
      const label = checkbox.closest('.fabric-sample-label');
      if (label) {
        label.classList.remove('selected');
      }
    }

    // Remove from array
    selectedSamples = selectedSamples.filter(function(sample) {
      return sample.id !== variantId;
    });

    updateUI();
  }

  function addSamplesToCart() {
    const addButton = document.getElementById('add-fabric-samples');

    if (selectedSamples.length === 0) {
      alert('Please select at least one fabric sample.');
      return;
    }

    // Disable button during processing
    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    // Get the main product variant ID from the data attribute
    const wrapper = document.querySelector('.free-fabric-sample-wrapper');
    const mainProductVariantId = wrapper?.dataset.mainVariantId;
    
    if (!mainProductVariantId) {
      alert('Unable to find product. Please refresh the page.');
      addButton.disabled = false;
      addButton.textContent = 'Add Samples to Cart';
      return;
    }

    // Build properties with selected fabric samples
    const properties = {
      '_Sample Request': 'Free Fabric Sample'
    };
    
    // Add each selected sample as a property with full name
    selectedSamples.forEach(function(sample, index) {
      // Use the full variant title stored in the data
      const fullTitle = sample.fullTitle || sample.title;
      properties['Sample ' + (index + 1)] = fullTitle;
    });

    // Add main product with properties
    const cartItem = {
      id: mainProductVariantId,
      quantity: 1,
      properties: properties
    };

    // Add to cart using Shopify AJAX API
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [cartItem] })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Success - redirect to cart
      addButton.textContent = 'Added!';
      
      // Redirect to cart page
      window.location.href = '/cart';
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      addButton.disabled = false;
      addButton.textContent = 'Add Samples to Cart';
      alert('There was an error adding samples to cart. Please try again.');
    });
  }

  // Expose functions for external use
  window.FreeFabricSample = {
    getSelectedSamples: function() {
      return selectedSamples;
    },
    clearSelection: function() {
      selectedSamples = [];
      updateUI();
    }
  };
})();
